import React from "react";
import Confetti from "react-dom-confetti";

import { withRouter, Route, Switch, Link } from "react-router-dom";
import {
  RiEarthLine,
  RiCheckboxMultipleLine,
  RiBookletLine,
  RiCopperCoinLine,
  RiShieldUserLine,
} from "react-icons/ri";
import { IconContext } from "react-icons";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import HomeView from "./views/home";
import InsertView from "./views/insert";
import TagsView from "./views/tags";
import CreditsView from "./views/credits";
import AccountView from "./views/account";
import TransitionWrap from "./components/TransitionWrap";
import Emoji from "./components/primatives/Emoji";
import ScrollView from "./components/ScrollView";
import logo from "./images/put_logo_icon_d.png";

import "./index.css";

import put from "./helpers/put";
import state from "./helpers/state";
import sls from "./helpers/sls";

class App extends React.Component {
  constructor(props) {
    super(props);

    const loadState = state.get();
    this.state = {
      ram: "XXX",
      credits: "XXX",
      confetti: false,
      loadState,
    };

    this.helper_refreshApp = this.helper_refreshApp.bind(this);
    this.helper_loadState = this.helper_loadState.bind(this);
    this.helper_put = this.helper_put.bind(this);
    this.helper_sls = this.helper_sls.bind(this);
    this.helper_launchConfetti = this.helper_launchConfetti.bind(this);
    this.helpers = this.helpers.bind(this);

    this.renderAccountDetails = this.renderAccountDetails.bind(this);
  }

  async helper_refreshApp() {
    const loadState = state.get(); // re-load store

    let ram, credits;
    try {
      ram = await this.helper_put().ram(); // get ram()
      ram = ram.free; // get available ram
    } catch (e) {
      console.log("could not load ram");
      ram = this.state.ram;
    }
    try {
      credits = await this.helper_put().credits(); // get credits
    } catch (e) {
      console.log("could not load credits");
      credits = this.state.credits;
    }

    this.setState({ loadState, credits, ram });
  }
  helper_loadState() {
    return this.state.loadState;
  }
  helper_put() {
    return put(this.state.loadState);
  }
  helper_sls() {
    return sls(this.state.loadState);
  }
  helper_launchConfetti() {
    this.setState({ confetti: true }, () => {
      this.setState({ confetti: false });
    });
  }

  helpers() {
    return {
      refreshApp: this.helper_refreshApp,
      loadState: this.helper_loadState,
      put: this.helper_put,
      sls: this.helper_sls,
      launchConfetti: this.helper_launchConfetti,
    };
  }

  // ------------

  async componentDidMount() {
    this.helper_refreshApp();
  }

  renderAccountDetails() {
    let { loadState } = this.state;
    let { account } = loadState;

    return (
      <div>
        <div className="inline-block relative w-full mb-2 text-center">
          <div className="text-gray-700 font-extrabold">
            {account.key ? (
              <div className="text-3xl">My Dashboard</div>
            ) : (
              <div className="text-3xl">Dashboard</div>
            )}
          </div>
          <div className="text-lg text-gray-600">
            {account.key ? account.name : "tap to login or signup"}
          </div>
        </div>
      </div>
    );
  }

  render() {
    // get page..
    const page = this.props.location.pathname;

    return (
      <div className="flex flex-col">
        <Link to="/" className="m-10 mb-10">
          <img
            src={logo}
            alt="put logo"
            style={{ maxWidth: "250px" }}
            className="block m-auto"
          />
        </Link>

        <IconContext.Provider
          value={{
            style: {
              display: "inline-flex",
              alignSelf: "center",
              marginBottom: "0.1em",
              color: "#6973DB",
            },
          }}
        >
          <TransitionWrap>
            <main className="container mx-auto w-full max-w-sm mb-32">
              <div className="max-w-sm overflow-hidden shadow-2xl bg-white rounded">
                <Link to="/account">
                  <div className="w-full bg-gray-400 hover:bg-gray-300 px-10 py-10">
                    {this.renderAccountDetails()}
                  </div>
                </Link>
                <div className="relative mb-6">
                  <div
                    className="absolute text-xl text-gray-700 text-center w-full"
                    style={{ top: "-0.75em" }}
                  >
                    <table className="text-center w-full">
                      <tbody>
                        <tr>
                          <td className="pl-5">
                            <span className="shadow bg-white p-2 rounded">
                              <Emoji type="storage" />
                              <b className="text-gray-600 text-lg">
                                {" "}
                                {Number(
                                  this.state.ram > 0 ? this.state.ram : 0
                                ).toPrecision(5)}
                              </b>
                            </span>
                          </td>
                          <td>
                            <Link
                              to="/credits"
                              className="shadow bg-white p-3 cursor-pointer hover:text-indigo-700 text-gray-700 hover:bg-gray-100 rounded"
                            >
                              <b>Credits</b>
                            </Link>
                          </td>
                          <td className="pr-5">
                            <span className="shadow bg-white p-2 rounded">
                              <Emoji type="cpu" />
                              <b className="text-gray-600 text-lg">
                                {" "}
                                {Number(
                                  this.state.credits > 0
                                    ? this.state.credits
                                    : 0
                                ).toPrecision(5)}
                              </b>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="p-6">
                  <ScrollView>
                    <Switch>
                      <Route
                        path="/"
                        render={(props) => (
                          <HomeView {...props} helpers={this.helpers()} />
                        )}
                        exact
                      />
                      <Route
                        path="/insert"
                        render={(props) => (
                          <InsertView {...props} helpers={this.helpers()} />
                        )}
                        exact
                      />
                      <Route
                        path="/tags"
                        render={(props) => (
                          <TagsView {...props} helpers={this.helpers()} />
                        )}
                        exact
                      />
                      <Route
                        path="/credits"
                        render={(props) => (
                          <CreditsView {...props} helpers={this.helpers()} />
                        )}
                        exact
                      />
                      <Route
                        path="/account"
                        render={(props) => (
                          <AccountView {...props} helpers={this.helpers()} />
                        )}
                        exact
                      />
                    </Switch>
                  </ScrollView>
                </div>
              </div>
            </main>
          </TransitionWrap>
        </IconContext.Provider>

        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        {/* fixed footer */}
        <footer className="fixed bg-white shadow-2xl border-gray-200 border-t w-screen bottom-0 text-center">
          <div className="max-w-lg p-4 block m-auto">
            <div className="flex flex-row">
              <div
                className={`flex-1 ${
                  page === "/" ? `text-indigo-700` : `text-gray-500`
                }`}
              >
                <Link to="/">
                  <RiEarthLine className="block m-auto" size="2.4em" />{" "}
                  <div className="text-xs">explore</div>
                </Link>
              </div>
              <div
                className={`flex-1 ${
                  page === "/insert" ? `text-indigo-700` : `text-gray-500`
                }`}
              >
                <Link to="/insert">
                  <RiCheckboxMultipleLine
                    className="block m-auto"
                    size="2.4em"
                  />{" "}
                  <div className="text-xs">insert</div>
                </Link>
              </div>
              <Confetti
                    active={this.state.confetti}
                    config={{
                      colors: ["#6D6DAA", "#C7E9FF"],
                      elementCount: 120,
                      stagger: 10,
                      spread: 50,
                      angle: 85
                    }}
                  />
              <div
                className={`flex-1 ${
                  page === "/credits" ? `text-indigo-700` : `text-gray-500`
                }`}
              >
                <Link to="/credits">
                  <RiCopperCoinLine className="block m-auto" size="2.4em" />{" "}
                  <div className="text-xs">credits</div>
                </Link>
              </div>

              <div
                className={`flex-1 ${
                  page === "/tags" ? `text-indigo-700` : `text-gray-500`
                }`}
              >
                <Link to="/tags">
                  <RiBookletLine className="block m-auto" size="2.4em" />{" "}
                  <div className="text-xs">my tags</div>
                </Link>
              </div>
              <div
                className={`flex-1 ${
                  page === "/account" ? `text-indigo-700` : `text-gray-500`
                }`}
              >
                <Link to="/account">
                  <RiShieldUserLine className="block m-auto" size="2.4em" />{" "}
                  <div className="text-xs">account</div>
                </Link>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

const AppWithRouter = withRouter((props) => <App {...props} />);
export default AppWithRouter;
